module.exports = __webpack_public_path__ + "static/media/jr-circle.66661de5.svg";